import { Control, Controller } from 'react-hook-form'
import { ITextArea, TextArea } from 'src/common'

export const HookFormTextArea = ({
  control,
  controlName,
  onInputChange,
  ...props
}: Omit<ITextArea, 'value' | 'errors'> & {
  control: Control<any, any>
  controlName: string
  onInputChange?: () => void
}) => {
  return (
    <Controller
      name={controlName}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <TextArea
            {...props}
            value={value}
            onChange={(e) => {
              onChange(e?.target?.value)
              if (props?.onChange) {
                props.onChange(e)
              }
              onInputChange?.()
            }}
            errors={error?.message}
          />
        )
      }}
    />
  )
}
